import { ACTUAL_STATEMENT, EXTRA_STATEMENT, TAX_STATEMENT, YEARLY_STATEMENT, YEARLY_STATEMENT_ONLY_LAST_YEAR } from "./constants";

export const API_STATEMENT_MAPPING = {
    [YEARLY_STATEMENT]: YEARLY_STATEMENT,
    [YEARLY_STATEMENT_ONLY_LAST_YEAR]: YEARLY_STATEMENT,
    [EXTRA_STATEMENT]: EXTRA_STATEMENT,
    [TAX_STATEMENT]: TAX_STATEMENT,
    [ACTUAL_STATEMENT]: ACTUAL_STATEMENT,
};
